<template>
  <v-layout>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-md-6 col-xs-12">
          <div class="card mt-5">
            <div class="card-body">
              <h4>{{ $t('login.passwordReset') }}</h4>
              <form @submit.prevent="reset">
                <div class="form-group">
                  <label>{{ $t('login.enterNewPassword') }}</label>
                  <VPasswordStrengthMeter
                    :secureLength="secureLength"
                    v-model="password"
                    defaultClass="form-control"
                    :disabled="resetCodeInvalid"
                  />
                </div>
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control"
                           v-model="password2"
                           type="password"
                           :placeholder="$t('login.repeatPassword')"
                           :disabled="resetCodeInvalid"
                    >
                  </div>
                  <small v-if="password2 && !passwordValid" class="text-danger">
                    {{ $t('login.passwordsDontMatch') }}
                  </small>
                </div>
                <div class="form-group">
                  <button class="btn btn-block"
                          v-if="!resetCodeInvalid"
                          type="submit"
                          :disabled="!passwordValid"
                          :class="{'btn-outline-primary' : !passwordValid, 'btn-primary': passwordValid}"
                  >
                    {{ $t('Submit') }}
                  </button>
                  <router-link v-else
                    :to="{ name: 'login.index' }"
                    class="btn btn-primary btn-block"
                    tag="button"
                  >
                    {{ $t('Back') }}
                  </router-link>
                </div>
              </form>
              <div class="text-center">
                <div v-if="working" class="spinner-border text-primary text-center"></div>
              </div>
              <div class="alert alert-success" v-if="success">
                <h4 class="alert-heading">{{ $t('Success') }}</h4>
                <p>{{ $t('login.passwordSuccessfullyReset') }}</p>
              </div>
              <div class="alert alert-danger"
                   v-if="error"
              >
                <h4 class="alert-heading">{{ $t('Error') }}</h4>
                {{ $t(error) }}
              </div>
            </div>
            <div class="card-footer">
              <router-link
                :to="{ name: 'login.index' }"
                class="card-link"
                tag="a"
              >
                {{ $t('Back') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
  import VLayout from '@/layouts/MinimalWithNav.vue';
  import VPasswordStrengthMeter from 'vue-password-strength-meter';

  export default {
    name: 'ResetPasswordIndex',
    components: {
      VLayout,
      VPasswordStrengthMeter,
    },

    computed: {
      passwordValid() {
        return this.password
          && this.password.length >= this.secureLength
          && this.password === this.password2;
      },
      passwordResetUid() {
        return this.$route.params.passwordResetUid;
      }
    },

    data() {
      return {
        resetCodeInvalid: false,
        success: false,
        working: false,
        error: '',
        secureLength: 5,
        password: '',
        password2: '',
      }
    },

    mounted() {
      this.check()
    },

    methods: {
      reset() {
        const self = this;
        self.working = true;
        self.success = false;
        self.error = '';

        $.ajax({
          type: 'post',
          url: process.env.VUE_APP_API_LOCATION + '/forgot-password/reset',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            password: self.password,
            passwordResetUid: self.passwordResetUid
          }),
        })
        .done(()=>{
          self.success = true;
          self.resetCodeInvalid = true;
        })
        .fail((jqXHR)=>{
          self.error = _.get(jqXHR, 'responseJSON.message')
        })
        .always(()=>{
          self.working = false;
        })
      },
      check() {
        const self = this;
        self.working = true;
        $.getJSON(process.env.VUE_APP_API_LOCATION + '/forgot-password/check/' + self.passwordResetUid)
          .fail((jqXHR)=>{
            self.resetCodeInvalid = true;
            self.error= _.get(jqXHR, 'responseJSON.message')
          })
          .always(()=>{
            self.working = false;
          })
      }
    },
  };
</script>
